import { Box, Button, FormControl, Grid, makeStyles, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import theme from "theme";
import SearchCaseForm from "../components/SearchCaseForm";
import { caseWeeding, getSearchFormDetailsMainCase } from "../API/TdsatApi";
import DatePickerTDSAT from "../components/DatePickerTDSAT";
import { format } from "date-fns";
import { useSnackbar } from "contexts/SnackbarContext";
import { PrintOutlined } from "@material-ui/icons";
import MessageBox from "../components/MessageBox";
import validateDateAndFormat from "utils/validateDateAndFormat";
import { RequiredLabel } from "features/loginTdsat/Signup";

const useStyles = makeStyles((theme)=>({
  entryForm: {
    width: '75%',
    margin: 'auto',
  },
  paper: {
    padding: `3rem 6rem`,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
    borderRadius: '0.625rem',
  },
  button: {
    padding: '0.7rem 2rem',
    borderRadius: '0.75rem',
    fontSize: '1.25rem',
    margin: '2rem',
  },
  formHeading: {
    fontSize: '1.375rem',
    fontFamily: 'Satoshi-Bold',
    color: theme.palette.primary.main,
    textAlign: 'left',
  },
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
}))

export default function CaseWeeding({handleClickGenerateReport}){
  const classes = useStyles();

  const [searchFormData, setSearchFormData] = useState({
    selectType: 'caseNumber',
    case_number: '',
    case_type: '',
    year: '',
  });
  const [formData, setFormData] = useState({
    date_of_weeding: null,
    reason: '',
    other: '',
  })
  const [searchResponse, setSearchResponse] = useState(null);

  const { showSnackbar } = useSnackbar();

  const handleInputChangeSearch = (e) => {
    const { name, value } = e.target;
    setSearchFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputDateOfWeeding = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      'date_of_weeding': value,
    }));
  }

  const handleSearch = async (searchParams) => {
    try {
      const caseNumber = searchParams?.case_number;
      const year = searchParams.year;
      const caseType = searchParams.case_type;
      const diaryNumber = searchParams?.diary_number;
      const response = await getSearchFormDetailsMainCase(caseNumber, year, caseType, "case_weeding", diaryNumber);
      console.log(response?.data);
      setSearchResponse(response?.data);
      setFormData({
        date_of_weeding: null,
        reason: '',
        other: '',
      })
    } catch (error) {
      console.error("Error searching case:", error);
      if(error?.response?.status === 400){
        showSnackbar(error?.response?.data?.error, 'error');
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(formData);
    const {date_of_weeding,reason,other} = formData
    if(date_of_weeding === null || reason === ''){
      alert('Please select Date of Weeding and reason.');
      return;
    }
    const data = {
      "case_id": searchResponse?.case_data?.id,
      "date_of_weeding": validateDateAndFormat(date_of_weeding, 'dd-MM-yyyy'),
      "reason_for_weeding": reason === 'Other' ? other : reason,
      "disposal_date": validateDateAndFormat(searchResponse?.disposal_date, 'dd-MM-yyyy'),
      "case_type": searchFormData?.case_type,
    }
    caseWeeding(data).then((res)=>{
      // console.log(res?.data);
      if(res?.data?.message){
        showSnackbar(res?.data?.message, "success");
        setFormData({
          date_of_weeding: null,
          reason: '',
          other: '',
        })
        setSearchResponse(null);
      }
    }).catch((error)=>{
      console.log('There is some glitch in getting Cause list data: ', error);
      if(error?.response?.status === 400){
        showSnackbar(error?.response?.data?.error, 'error');
      }
    })
  }
  
  return (
    <Box>
      <Box className={classes.entryForm}>
        <Box style={{display:'flex', gap:'1rem', justifyContent:'space-between'}}>
          <Typography style={{fontSize:'1.5rem'}}>
            CASE WEEDING 
          </Typography>
          <Button
            color="primary"
            variant="contained"
            onClick={()=> handleClickGenerateReport('weeding_out_report')}
            endIcon={<PrintOutlined/>}
          >
            Generate Report
          </Button>
        </Box>
        <Box style={{height:'1.5rem'}}/>
        <SearchCaseForm
          handleInputChange={handleInputChangeSearch}
          classes={classes}
          handleSearch={handleSearch}
          formData={searchFormData}
        />
        {searchResponse && (
          <>
            <MessageBox
              title={searchResponse?.message}
            />
            <Box style={{height:'2rem'}}></Box>
            <Grid container spacing={2} style={{backgroundColor:'white', padding:'3rem 6rem', borderRadius: '0.625rem', marginBottom:'2rem'}}>
              <Grid item xs={12}>
                <Typography className={classes.formHeading}>
                  {searchResponse?.case_data?.name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="left">Disposal Date:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="left">{validateDateAndFormat(searchResponse?.disposal_date, 'dd/MM/yyyy')}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="left">Disposal Remarks:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="left">{searchResponse?.remarks}</Typography>
              </Grid>
            </Grid>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2} style={{backgroundColor:'white', padding:'3rem 6rem', borderRadius: '0.625rem'}}>
                <Grid item xs={12}>
                  <FormControl fullWidth margin="none" variant="outlined">
                    <RequiredLabel className={classes.label} label={'Date of Weeding'}/>
                    <DatePickerTDSAT
                      date={formData.date_of_weeding}
                      setDate={handleInputDateOfWeeding}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl required fullWidth margin="none" variant="outlined">
                    <RequiredLabel className={classes.label} label={'Reason For Weeding'}/>
                    <Select
                      name="reason"
                      value={formData.reason}
                      onChange={handleInputChange}
                    >
                      <MenuItem>Select</MenuItem>
                      <MenuItem value='As per Chapter B of TDSAT procedure 2001'>As per Chapter B of TDSAT procedure 2001</MenuItem>
                      <MenuItem value= 'Other'>Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {formData?.reason === 'Other' && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="Please specify other reason"
                    name="other"
                    value={formData.other}
                    onChange={handleInputChange}
                    variant="outlined"
                  />
                </Grid>
              )}
              </Grid>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
                // disabled={(date === null || benchNature === '' || courtNumber === '')}
                // onClick={()=>console.log(formData)}
              >
                Submit
              </Button>
              <Box style={{height:'2rem'}}></Box>
            </form>
          </>
        )}
        
      </Box>
    </Box>
  )
}